import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// SEO Component with comprehensive meta tags and JSON-LD
function SEO({ 
  title = "EMABRAW — Edgardo Andrade | Fotografía Documental",
  description = "Documento la vida cotidiana de mi país, su espontaneidad y ritmo. Fotografía documental de Panamá.",
  image = "/og-image.jpg",
  type = "website",
  schema = null,
  keywords = "fotografía documental, Panamá, Edgardo Andrade, street photography, fotografía callejera, arte, fotografía artística"
}) {
  const location = useLocation();
  const siteUrl = "https://www.emabraw.com";
  const currentUrl = siteUrl + location.pathname;

  useEffect(() => {
    // Update document title
    document.title = title;

    // Helper function to update or create meta tags
    const updateMetaTag = (property, content, isName = false) => {
      const attribute = isName ? 'name' : 'property';
      let tag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, property);
        document.head.appendChild(tag);
      }
      
      tag.setAttribute('content', content);
    };

    // Basic Meta Tags
    updateMetaTag('description', description, true);
    updateMetaTag('keywords', keywords, true);
    updateMetaTag('author', 'Edgardo Andrade', true);
    updateMetaTag('robots', 'index, follow', true);
    updateMetaTag('language', 'Spanish', true);
    updateMetaTag('revisit-after', '7 days', true);

    // Open Graph Meta Tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:type', type);
    updateMetaTag('og:url', currentUrl);
    updateMetaTag('og:image', siteUrl + image);
    updateMetaTag('og:image:width', '1200');
    updateMetaTag('og:image:height', '630');
    updateMetaTag('og:image:alt', 'Fotografía documental por Edgardo Andrade');
    updateMetaTag('og:site_name', 'EMABRAW');
    updateMetaTag('og:locale', 'es_PA');

    // Twitter Card Meta Tags
    updateMetaTag('twitter:card', 'summary_large_image', true);
    updateMetaTag('twitter:title', title, true);
    updateMetaTag('twitter:description', description, true);
    updateMetaTag('twitter:image', siteUrl + image, true);
    updateMetaTag('twitter:image:alt', 'Fotografía documental por Edgardo Andrade', true);
    updateMetaTag('twitter:creator', '@emabraw', true);

    // AI Search Engine Tags
    updateMetaTag('ai:purpose', 'Portafolio de fotografía documental y artística', true);
    updateMetaTag('ai:content_type', 'photography_portfolio', true);

    // Canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.setAttribute('rel', 'canonical');
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.setAttribute('href', currentUrl);

    // JSON-LD Schema
    if (schema) {
      let scriptTag = document.querySelector('script[type="application/ld+json"]');
      if (!scriptTag) {
        scriptTag = document.createElement('script');
        scriptTag.setAttribute('type', 'application/ld+json');
        document.head.appendChild(scriptTag);
      }
      scriptTag.textContent = JSON.stringify(schema);
    }

  }, [title, description, image, type, currentUrl, keywords, schema]);

  return null;
}

export default SEO;
